import template from './contactsList.template.html';

export default {
  template,
  bindings: {
    contacts: '=',
    labels: '=',
    onDelete: '&',
    onLabelsSelect: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.contacts, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      ctrl.contactDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.contactLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.getLabel = (idLabel) => ctrl.labels.find((l) => l.id === idLabel);

      ctrl.areAllItemsSelected = () => {
        if (ctrl.contacts.length) {
          return _.every(ctrl.contacts, (j) => j.isSelected);
        }
        return false;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
